export default __webpack_public_path__ + "static/media/s_wdt_c_0_1.6eb6628c.mp3";